import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { ChevronRight, Home } from 'lucide-react'

interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav className={cn('flex items-center gap-2 text-sm', className)} aria-label="Fil d'ariane">
      <Link
        to="/dashboard"
        className="text-brown-400 hover:text-brown-600 transition-colors"
        aria-label="Accueil"
      >
        <Home className="w-4 h-4" />
      </Link>

      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          <ChevronRight className="w-4 h-4 text-brown-300" />
          {item.href ? (
            <Link
              to={item.href}
              className="text-brown-500 hover:text-brown-700 transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-brown-700 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  )
}
